import React from 'react';

export const withHeader = (Component: React.FC) => (props: IHeaderProps) => {
  if (!props.header) return <Component {...(props as any)} />;

  return (
    <>
      {props.header}
      <Component {...(props as any)} />
    </>
  );
};

export interface IHeaderProps {
  header?: React.ReactNode;
}
